import React from "react";

import { keyBy } from "lodash";
import { format } from "date-fns";

import { DateFormat } from "utilities/dist/invoice/constants";
import { buildTabcId } from "utilities/dist/customer/helpers";
import { InvoiceLinkRenderer } from "../../invoice/grid/cellRenderers.component";

export const allGridColumns = keyBy(
    [
        {
            hide: true,
            field: "roll_id",
            type: "numericColumn",
            filter: "agNumberColumnFilter",
        },
        {
            field: "invoice.customer.name",
            headerName: "Customer",
            // Use all 4 columns until invoice link because we won't have any of those data for destroyed invoice
            colSpan: ({ data }) => (!data?.invoice && data?.note ? 3 : 1),
            cellRenderer: function ({ data }) {
                if (data && !data?.invoice_id) {
                    return (
                        <span style={{ color: "red" }}>
                            [DESTROYED]{!!data.note && ` ${data.note}`}
                        </span>
                    );
                }
                if (!data?.invoice?.customer) return null;
                return (
                    <>
                        {data.invoice.customer.name}
                        <br />
                        {data.invoice.customer.address}
                    </>
                );
            },
            valueGetter: function ({ data }) {
                if (data && !data?.invoice_id) {
                    if (data.note) {
                        return `[DESTROYED] ${data.note}`;
                    }
                    return `[DESTROYED]`;
                }
                return data?.invoice?.customer
                    ? `${data.invoice.customer.name}, ${data.invoice.customer.address}`
                    : null;
            },
            filter: "agTextColumnFilter",
        },
        {
            sortable: false,
            headerName: "TABC ID",
            field: "invoice.customer.tabc_id",
            valueGetter: function ({ data }) {
                return !data ? null : buildTabcId(data.invoice?.customer);
            },
            filter: "agTextColumnFilter",
        },
        {
            headerName: "Invoice",
            field: "invoice.number",
            cellRenderer: InvoiceLinkRenderer,
            valueGetter: function ({ data }) {
                return data?.invoice?.number || null;
            },
            filter: "agTextColumnFilter",
        },
        {
            field: "logged_at",
            headerName: "Date",
            valueGetter: ({ data }) => {
                if (!data) return null;
                if (data.logged_at) {
                    return format(new Date(data.logged_at), DateFormat);
                }
                return null;
            },
            filter: "agDateColumnFilter",
        },
        {
            width: 100,
            field: "prefix",
            sortable: false,
            headerName: "Prefix",
            filter: "agTextColumnFilter",
        },
        {
            field: "from",
            type: "numericColumn",
            headerName: "Start Stamp",
            filter: "agNumberColumnFilter",
            valueGetter: function ({ data }) {
                return data ? `${data.prefix || ""}${data.from}` : null;
            },
        },
        {
            field: "to",
            type: "numericColumn",
            headerName: "End Stamp",
            filter: "agNumberColumnFilter",
            valueGetter: function ({ data }) {
                return data ? `${data.prefix || ""}${data.to}` : null;
            },
        },
        {
            sortable: false,
            field: "stamp_count",
            type: "numericColumn",
            headerName: "Used",
            filter: false,
            // filter: "agNumberColumnFilter",
            cellRenderer: function ({ data }) {
                if (!data || !data.from) return 0;
                let text = data.to - data.from + 1;
                if (!data?.invoice_id) {
                    return (
                        <>
                            {text}
                            <br />
                            DESTROYED
                        </>
                    );
                }
                return text;
            },
            valueFormatter: function ({ data }) {
                if (!data || !data.from) return 0;
                return data.to - data.from + 1;
            },
            valueGetter: function ({ data }) {
                if (!data || !data.from) return 0;
                const val = data.to - data.from + 1;
                return data?.invoice_id ? val : `${val}[DESTROYED]`;
            },
            "data-cy": "stamp_used",
        },
        {
            sortable: false,
            type: "numericColumn",
            field: "stamp_balance",
            headerName: "Balance",
            filter: false,
            // filter: "agNumberColumnFilter",
            valueFormatter: function ({ data }) {
                if (!data || !data.from || !data.stampRoll) return "-";
                return data.stampRoll.to - data.to;
            },
            valueGetter: function ({ data }) {
                if (!data || !data.from || !data.stampRoll) return "-";
                return data.stampRoll.to - data.to;
            },
        },
    ],
    "field"
);
